import React from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { DateRangeFilter } from 'components/Filter/DateRangeFilter'
import { TimeRangeInputs } from './TimeRangeInputs'
import { FiltersSchema } from '../filtersSchema'

export const TimeRangeFilters = () => {
  const methods = useFormContext<FiltersSchema>()
  return (
    <FormProvider {...methods}>
      <DateRangeFilter<FiltersSchema>
        dateRangeFieldPath="timeRange.dateRange"
        typeFieldPath="timeRange.type"
        label="Time Range"
        filterKey="time-range"
      >
        <TimeRangeInputs />
      </DateRangeFilter>
    </FormProvider>
  )
}
